const SCOPES = "api.artifact api.graphcms api.kvs api.learnosity api.logger api.manager api.permissions api.sequencer api.settings api.studentdata api.transfer api.assessment openid api.datagather api.semaphore";

const IMLPSCOPES = "Scope.IL.Artifact Scope.IL.Graphcms Scope.IL.KVS Scope.IL.Learnosity Scope.IL.Logger Scope.IL.Permissions Scope.IL.Sequencer Scope.IL.Settings Scope.IL.StudentData Scope.IL.Auth.Transfer Scope.IL.Assessment Scope.IL.Datagather Scope.IL.Semaphore Scope.IL.Registration openid"

export default SCOPES;

export {IMLPSCOPES};


// WEBPACK FOOTER //
// ./src/constants/scopes.js